import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
import { CheckOutlined, DropboxOutlined } from "@ant-design/icons";

const DEFAULT_SIZE = 100; // full width

const BoxComponent = ({ filteredColumns, noOfColumns }) => {
  const { t } = useTranslation();

  const BoxContainer = ({ box, index }) => {
    const isFilled = box?.boxInfo?.boxName ? true : false;
    const isScanned = box?.boxInfo?.isScanned;
    const isBatchesBoxComplete =
      box?.boxInfo?.numOfParcels === box?.boxInfo?.noOfExpectedParcels;

    const retrieveBoxProperty = () =>
      isBatchesBoxComplete ? "batch-complete" : isScanned ? "filling" : "";

    const rowSize =
      noOfColumns !== 0 && noOfColumns
        ? DEFAULT_SIZE / noOfColumns
        : DEFAULT_SIZE; // prevent div_by_0

    return (
      <Col flex={`${rowSize}%`} key={index}>
        {!isFilled ? (
          <div className={"dm-fs-container inactive"}>
            <div className="dm-fs-title">
              <span className="fs-sm-title">{box.columnNo}</span>
            </div>
          </div>
        ) : (
          <div className={`dm-fs-container ${retrieveBoxProperty()}`}>
            <Row>
              <Col
                span={24}
                className={`dm-fs-inner-heading ${retrieveBoxProperty()}`}
              >
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <div className="dm-fs-title">
                      <div className="dm-fs-rack-number">
                        <span className="rack-number-text">{box.columnNo}</span>
                        {isBatchesBoxComplete ? (
                          <CheckOutlined className="rack-number-icon" />
                        ) : (
                          <DropboxOutlined className="rack-number-icon" />
                        )}
                      </div>
                      <span className="dm-fs-box-name">
                        {box?.boxInfo?.boxName}
                      </span>
                    </div>
                  </Col>
                  {isFilled && (
                    <Col span={24}>
                      <div className="dm-fs-subtitle box-page">
                        {box?.boxInfo?.numOfParcels ?? "0"}
                        {box?.boxInfo?.noOfExpectedParcels &&
                          ` / ${box.boxInfo.noOfExpectedParcels}`}
                      </div>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </div>
        )}
      </Col>
    );
  };

  return (
    <div className="dfs-box-component">
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            {filteredColumns?.columns?.map((box, childIndex) => (
              <BoxContainer box={box} index={childIndex} key={childIndex} />
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default BoxComponent;
